import React from 'react'
import { UnorderedList } from 'evergreen-ui'

class UnstyledList extends React.PureComponent {
  static propTypes = {
    ...UnorderedList.propTypes
  }

  static defaultProps = {
    ...UnorderedList.defaultProps
  }

  render() {
    return (
      <UnorderedList
        listStyle="none"
        marginLeft={0}
        paddingLeft={0}
        {...this.props}
      />
    )
  }
}

export default UnstyledList
